/* Lombra — scripts du thème */
(function(){
  const L = window.LOMBRA || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  /* ---------- argent ---------- */
  function money(cents){
    const fmt = L.moneyFormat || '{{amount_with_comma_separator}} €';
    const n = (cents || 0) / 100;
    const fix = (v, d, ts, ds) => {
      const parts = v.toFixed(d).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts);
      return parts.join(d ? ds : '');
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => {
      switch (k) {
        case 'amount': return fix(n, 2, ',', '.');
        case 'amount_no_decimals': return fix(n, 0, ',', '.');
        case 'amount_with_comma_separator': return fix(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fix(n, 0, '.', ',');
        case 'amount_with_space_separator': return fix(n, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return fix(n, 0, ' ', ',');
        default: return fix(n, 2, ' ', ',');
      }
    }).replace(/<[^>]*>/g, '');
  }
  const esc = s => String(s == null ? '' : s).replace(/[&<>"]/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]));
  function toast(t){ const e = $('#toast'); if (!e) return; e.textContent = t; e.classList.add('on'); clearTimeout(e._h); e._h = setTimeout(() => e.classList.remove('on'), 2600); }

  /* ---------- panneaux ---------- */
  let lastFocus = null;
  const scrim = () => $('#scrim');
  function openPanel(id){
    lastFocus = document.activeElement; closePanels(true);
    const p = document.getElementById(id); if (!p) return;
    p.classList.add('on'); p.setAttribute('aria-hidden', 'false');
    scrim().hidden = false; document.body.classList.add('lock');
    setTimeout(() => { const c = p.querySelector('[data-close]'); c && c.focus(); }, 60);
  }
  function closePanels(silent){
    $$('.panel.on').forEach(p => { p.classList.remove('on'); p.setAttribute('aria-hidden', 'true'); });
    if (scrim()) scrim().hidden = true; document.body.classList.remove('lock');
    if (!silent && lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('click', e => {
    const o = e.target.closest('[data-open]'); if (o){ e.preventDefault(); openPanel(o.dataset.open); return; }
    if (e.target.closest('[data-close]') || e.target.id === 'scrim') closePanels();
    const oc = e.target.closest('[data-open-cart]'); if (oc){ e.preventDefault(); openCart(); }
    const st = e.target.closest('[data-search-toggle]');
    if (st){ const s = $('[data-search]'); s.hidden = !s.hidden; st.setAttribute('aria-expanded', String(!s.hidden)); if (!s.hidden) $('input[type=search]', s).focus(); }
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape'){ closePanels(); closeLB(); const s = $('[data-search]'); if (s) s.hidden = true; } });

  /* ---------- panier (API Ajax) ---------- */
  const R = L.routes || {};
  async function getCart(){ const r = await fetch((R.cart || '/cart') + '.js', { headers: { Accept: 'application/json' } }); return r.json(); }
  function setCount(n){ $$('[data-cart-count]').forEach(b => { b.textContent = n; b.dataset.n = n; }); }
  function renderCart(cart){
    setCount(cart.item_count);
    const body = $('#drawerBody'), foot = $('#drawerFoot'); if (!body) return;
    if (!cart.item_count){
      body.innerHTML = `<div class="empty" style="background:none;padding:40px 0"><b class="h3">Votre panier est vide</b><p class="muted">Choisissez une chaise et sa couleur.</p><a class="btn primary" href="${esc((R.root || '/') + 'collections/all')}">Voir les chaises</a></div>`;
      foot.innerHTML = ''; return;
    }
    body.innerHTML = (L.freeShippingText ? `<div class="freebar"><svg class="ic" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M3 6.5h11v9H3zM14 9.5h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/></svg><span>Livraison : ${esc(L.freeShippingText)}</span></div>` : '') +
      cart.items.map((it, i) => {
        const mt = String(it.product_title).match(/Lombra\s+([^\s,–]+)/); const name = mt ? 'Lombra ' + mt[1] : String(it.product_title).split(' – ')[0];
        const img = it.image ? it.image + (it.image.includes('?') ? '&' : '?') + 'width=240' : '';
        return `<div class="cl"><a class="th" href="${esc(it.url)}">${img ? `<img src="${esc(img)}" alt="" loading="lazy">` : ''}</a>
        <div><b>${esc(name)}</b>${it.variant_title ? `<small>${esc(it.variant_title)}</small>` : ''}
        <div class="q2"><div class="qty"><button type="button" data-line="${i + 1}" data-q="${it.quantity - 1}" aria-label="Retirer une unité">−</button><span class="num" style="min-width:22px;text-align:center;font-weight:600">${it.quantity}</span><button type="button" data-line="${i + 1}" data-q="${it.quantity + 1}" aria-label="Ajouter une unité">+</button></div>
        <button type="button" class="rm" data-line="${i + 1}" data-q="0">Retirer</button></div></div>
        <b class="num" style="font-size:16px">${money(it.final_line_price)}</b></div>`;
      }).join('');
    foot.innerHTML = `<div class="tot"><span>Sous-total</span><b class="num">${money(cart.items_subtotal_price)}</b></div>
      ${L.freeShippingText ? `<div class="tot"><span>Livraison</span><span>${esc(L.freeShippingText)}</span></div>` : ''}
      <div class="tot big"><span>Total TTC</span><span class="num">${money(cart.total_price)}</span></div>
      <a class="btn primary block" href="/checkout">Commander</a><a class="btn line block" href="${esc(R.cart || '/cart')}">Voir le panier</a>`;
  }
  async function openCart(){ openPanel('drawer'); try { renderCart(await getCart()); } catch(e){ window.location.href = R.cart || '/cart'; } }
  document.addEventListener('click', async e => {
    const b = e.target.closest('#drawer [data-line]'); if (!b) return;
    b.disabled = true;
    const r = await fetch((R.cart_change || '/cart/change') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: +b.dataset.line, quantity: Math.max(0, Math.min(9, +b.dataset.q)) }) });
    renderCart(await r.json());
  });
  async function addToCart(id, qty){
    const r = await fetch((R.cart_add || '/cart/add') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: qty }] }) });
    const j = await r.json();
    if (!r.ok){ toast(j.description || j.message || 'Impossible d’ajouter ce produit'); return false; }
    await openCart(); return true;
  }

  /* ---------- fiche produit ---------- */
  function initProduct(root){
    const dataEl = $('[data-product-json]'); if (!dataEl) return;
    const product = JSON.parse(dataEl.textContent);
    const form = $('[data-product-form]', root);
    const idInput = $('[data-variant-id]', root);
    const gal = $('[data-gallery]', root);
    const colorPos = gal ? +gal.dataset.colorPos : 0;
    let variant = product.variants.find(v => v.id == idInput.value) || product.variants[0];

    const sets = $$('.opt-set', form);
    function selected(){ return sets.map(s => { const c = $('input:checked', s); return c ? c.value : null; }); }
    function sync(){
      const opts = selected();
      const v = product.variants.find(x => x.options.every((o, i) => o === opts[i]));
      sets.forEach((s, i) => { const l = $('[data-option-label]', s); if (l) l.textContent = opts[i] || ''; });
      if (!v) return;
      variant = v; idInput.value = v.id;
      const pb = $('[data-price]', root);
      if (pb) pb.innerHTML = `<span class="price num">${money(v.price)}</span>${v.compare_at_price > v.price ? `<s class="compare num">${money(v.compare_at_price)}</s>` : ''}<small>TTC · livraison offerte</small>`;
      const add = $('[data-add]', root); add.disabled = !v.available; add.textContent = v.available ? 'Ajouter au panier' : 'Épuisé';
      const st = $('[data-stock]', root); if (st){ st.style.color = v.available ? '' : 'var(--muted)'; if (!v.available) st.textContent = 'Épuisé pour le moment'; else if (st.dataset.txt) st.textContent = st.dataset.txt; }
      const sv = $('[data-sticky-variant]'); if (sv) sv.textContent = v.title;
      const sp = $('[data-sticky-price]'); if (sp) sp.textContent = money(v.price) + ' · livraison offerte';
      const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u);
      filterGallery();
    }
    const st0 = $('[data-stock]', root); if (st0) st0.dataset.txt = st0.textContent;
    form.addEventListener('change', e => { if (e.target.name && e.target.name.startsWith('opt-')) sync(); });

    /* galerie : affiche les images dont le texte alternatif contient la couleur choisie */
    function filterGallery(){
      if (!gal) return;
      const items = $$('.gal-item', gal);
      const col = colorPos ? String(variant['option' + colorPos] || '').toLowerCase() : '';
      const match = col ? items.filter(it => (it.dataset.alt || '').includes(col)) : [];
      const show = match.length ? match : items;
      items.forEach(it => { it.hidden = !show.includes(it); it.classList.remove('first'); });
      if (variant.featured_media){
        const fm = items.find(it => it.dataset.mediaId == variant.featured_media.id);
        if (fm) fm.hidden = false;
      }
      const firstVis = items.find(it => !it.hidden); if (firstVis) firstVis.classList.add('first');
    }
    if (gal){
      $$('.gal-item', gal).forEach((it, i) => { const m = product.media && product.media[i]; if (m) it.dataset.mediaId = m.id; });
      filterGallery();
      gal.addEventListener('click', e => { const b = e.target.closest('.gal-item'); if (b && b.tagName === 'BUTTON') openLB(gal, b); });
    }

    /* quantité */
    const qIn = $('[data-qty-input]', root);
    $$('[data-qty]', root).forEach(b => b.addEventListener('click', () => { qIn.value = Math.max(1, Math.min(9, (+qIn.value || 1) + +b.dataset.qty)); }));

    form.addEventListener('submit', async e => {
      e.preventDefault();
      const add = $('[data-add]', root); add.disabled = true;
      await addToCart(variant.id, Math.max(1, +qIn.value || 1));
      add.disabled = !variant.available;
    });
    const sa = $('[data-sticky-add]'); if (sa) sa.addEventListener('click', () => addToCart(variant.id, 1));

    /* barre d’achat collante (mobile) */
    const row = $('[data-addrow]', root), sb = $('[data-stickybuy]');
    if (row && sb && 'IntersectionObserver' in window){
      new IntersectionObserver(([en]) => sb.classList.toggle('on', !en.isIntersecting && en.boundingClientRect.top < 0)).observe(row);
    }

    /* date de livraison estimée */
    const d = $('[data-delivery]', root), s = L.shipping;
    if (d && s){
      const add = (n) => { const x = new Date(); while (n > 0){ x.setDate(x.getDate() + 1); if (x.getDay() % 6) n--; } return x; };
      const f = x => x.toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' });
      d.textContent = `Livrée entre le ${f(add(s.handlingMin + s.transitMin))} et le ${f(add(s.handlingMax + s.transitMax))}`;
    }
  }

  /* lightbox */
  let LB = { items: [], i: 0 };
  function openLB(gal, btn){
    const lb = $('[data-lightbox]'); if (!lb) return;
    LB.items = $$('.gal-item', gal).filter(x => !x.hidden); LB.i = Math.max(0, LB.items.indexOf(btn));
    lb.hidden = false; document.body.classList.add('lock'); drawLB(); $('[data-lb-close]', lb).focus();
  }
  function drawLB(){
    const lb = $('[data-lightbox]'); const it = LB.items[LB.i]; if (!it) return;
    const img = $('img', it);
    $('[data-lb-stage]', lb).innerHTML = img ? `<img src="${esc(img.currentSrc || img.src)}" alt="${esc(img.alt)}">` : '';
    $('[data-lb-nav]', lb).innerHTML = LB.items.map((_, i) => `<button type="button" class="${i === LB.i ? 'on' : ''}" data-i="${i}" aria-label="Image ${i + 1}"></button>`).join('');
  }
  function closeLB(){ const lb = $('[data-lightbox]'); if (lb && !lb.hidden){ lb.hidden = true; document.body.classList.remove('lock'); } }
  document.addEventListener('click', e => {
    if (e.target.closest('[data-lb-close]')) closeLB();
    const n = e.target.closest('[data-lb-nav] button'); if (n){ LB.i = +n.dataset.i; drawLB(); }
  });
  document.addEventListener('keydown', e => {
    const lb = $('[data-lightbox]'); if (!lb || lb.hidden || !LB.items.length) return;
    if (e.key === 'ArrowRight'){ LB.i = (LB.i + 1) % LB.items.length; drawLB(); }
    if (e.key === 'ArrowLeft'){ LB.i = (LB.i + LB.items.length - 1) % LB.items.length; drawLB(); }
  });

  /* ---------- produits recommandés ---------- */
  function initRecos(){
    const el = $('[data-recos]'); if (!el || el.children.length) return;
    fetch(el.dataset.url).then(r => r.text()).then(html => {
      const tmp = document.createElement('div'); tmp.innerHTML = html;
      const inner = tmp.querySelector('[data-recos]'); if (inner && inner.innerHTML.trim()) el.innerHTML = inner.innerHTML;
    }).catch(() => {});
  }

  /* ---------- meilleures ventes (accueil) ---------- */
  function initBestSellers(){
    $$('[data-bestsellers]').forEach(grid => {
      const limit = +grid.dataset.limit || 4;
      fetch(grid.dataset.bestsellers).then(r => r.ok ? r.text() : '').then(html => {
        if (!html) return;
        const tmp = document.createElement('div'); tmp.innerHTML = html;
        const cards = $$('.card', tmp).slice(0, limit);
        if (cards.length){ grid.innerHTML = ''; cards.forEach(c => grid.appendChild(c)); }
      }).catch(() => {});
    });
  }

  /* ---------- collection : tri et filtres ---------- */
  function initCollection(){
    const form = $('[data-filter-form]'); if (!form) return;
    const sort = $('[data-sort]'); const hid = $('[data-sort-hidden]', form);
    if (sort) sort.addEventListener('change', () => { hid.value = sort.value; form.submit(); });
    $$('.filters input[type=checkbox]', form).forEach(i => i.addEventListener('change', () => form.submit()));
    const t = $('[data-filter-toggle]'); if (t) t.addEventListener('click', () => { const f = $('[data-filters]'); const o = f.classList.toggle('open'); t.setAttribute('aria-expanded', String(o)); });
    form.addEventListener('submit', () => { $$('input', form).forEach(i => { if (i.type === 'number' && !i.value) i.disabled = true; }); });
  }

  /* ---------- guide « trouver ma chaise » ---------- */
  function initQuiz(){
    const root = $('[data-quiz]'); const dataEl = $('[data-quiz-data]'); if (!root || !dataEl) return;
    let items = []; try { items = JSON.parse(dataEl.textContent); } catch(e){ return; }
    const tag = (p, k) => { const t = p.tags.find(x => x.toLowerCase().startsWith(k + ':')); return t ? t.slice(k.length + 1).trim() : ''; };
    const tags = (p, k) => p.tags.filter(x => x.toLowerCase().startsWith(k + ':')).map(x => x.slice(k.length + 1).trim().toLowerCase());
    items.forEach(p => { const a = tag(p, 'assise').split('-').map(x => parseFloat(String(x).replace(',', '.'))); p.seat = a.length === 2 && !isNaN(a[0]) ? a : null; p.usage = tag(p, 'usage').toLowerCase(); p.mat = tag(p, 'matiere').toLowerCase(); p.atouts = tags(p, 'atout'); p.incl = tag(p, 'inclinaison'); p.foot = tag(p, 'reposepieds') === 'oui'; });
    const form = $('[data-quiz-form]', root);
    const val = n => { const c = $(`input[name="${n}"]:checked`, form); return c ? c.value : ''; };
    const cm = n => String(n).replace('.', ',');
    function run(){
      const taille = +$('[data-taille]', root).value, ideal = Math.round(taille * 0.25 + 2);
      $('[data-taille-v]', root).textContent = taille + ' cm'; $('[data-ideal]', root).textContent = ideal + ' cm';
      const u = val('usage'), pr = val('prio'), m = val('mat');
      const sc = items.map(p => {
        let s = 0; const why = [];
        if (u === 'haute') s += p.usage === 'haute' ? 20 : -8;
        else { if (p.usage === 'haute') s -= 8; if (p.usage === u) s += 4; else if (u === 'ergonomique' && p.usage === 'relax') s += 2; else if (u === 'relax' && p.usage === 'ergonomique') s += 2; else s += 1; }
        if (pr === 'budget'){ const e = p.price / 100; s += e <= 80 ? 4 : e <= 110 ? 2 : 0; if (e <= 110) why.push('Prix contenu : ' + money(p.price)); }
        else if (p.atouts.includes(pr)){ s += 4; why.push({ dos: 'Pensée pour soutenir le dos', relax: p.incl ? 'S’incline jusqu’à ' + p.incl : 'Dossier inclinable', place: 'Se range facilement sous le bureau' }[pr]); }
        if (m !== 'egal' && p.mat){ if (p.mat === m){ s += 2; why.push({ maille: 'Maille respirante', similicuir: 'Similicuir facile à nettoyer', velours: 'Velours doux au toucher' }[m] || p.mat); } else s -= 2; }
        if (p.seat && p.usage !== 'haute'){ const ok = ideal >= p.seat[0] && ideal <= p.seat[1]; s += ok ? 2 : -3; if (ok) why.push(`Assise réglable à ${ideal} cm (${cm(p.seat[0])}–${cm(p.seat[1])} cm)`); }
        if (p.foot && (u === 'relax' || pr === 'relax')) why.push('Repose-pieds rétractable');
        return { p, s, why };
      }).sort((a, b) => b.s - a.s);
      const reco = $('[data-reco]', root);
      if (!sc.length){ reco.innerHTML = '<p class="muted">Ajoutez des produits à la boutique pour activer le guide.</p>'; return; }
      const b = sc[0], p = b.p;
      reco.innerHTML = `<span class="eyebrow">Notre recommandation</span>
        <div class="top"><div class="th">${p.img ? `<img src="${esc(p.img)}" alt="">` : ''}</div><div><h3>${esc(p.title)}</h3><p class="muted" style="margin:6px 0 10px">${esc(p.kind !== p.title ? p.kind : '')}</p><span class="price num">${money(p.price)}</span></div></div>
        <div class="why">${(b.why.length ? b.why : ['Bon compromis pour vos réponses']).slice(0, 4).map(w => `<div>${esc(w)}</div>`).join('')}</div>
        <a class="btn primary" href="${esc(p.url)}">Voir ${esc(p.title)}</a>
        ${sc.length > 1 ? `<div><p class="small muted" style="margin-bottom:8px">Autres options adaptées</p><div class="alts">${sc.slice(1, 3).map(x => `<a class="chip" href="${esc(x.p.url)}">${esc(x.p.title)} · ${money(x.p.price)}</a>`).join('')}</div></div>` : ''}`;
      const min = 40, max = 78, pc = v => ((v - min) / (max - min) * 100).toFixed(1) + '%';
      $('[data-hbars]', root).innerHTML = items.filter(x => x.seat).sort((a, c) => a.seat[0] - c.seat[0]).map(x => {
        const ok = ideal >= x.seat[0] && ideal <= x.seat[1];
        return `<a class="hb" href="${esc(x.url)}"><b>${esc(x.title)}</b><span class="bar"><span class="${ok ? 'ok' : ''}" style="left:${pc(x.seat[0])};width:calc(${pc(x.seat[1])} - ${pc(x.seat[0])})"></span><em style="left:${pc(ideal)}"></em></span><small class="num">${cm(x.seat[0])}–${cm(x.seat[1])}</small></a>`;
      }).join('');
    }
    form.addEventListener('change', run); $('[data-taille]', root).addEventListener('input', run); run();
  }

  document.addEventListener('DOMContentLoaded', () => {
    $$('[data-product-section]').forEach(initProduct);
    initRecos(); initBestSellers(); initCollection(); initQuiz();
    getCart().then(c => setCount(c.item_count)).catch(() => {});
  });
})();
